<template>
	<div id="panel-4" class="panel">
		<div class="panel-hdr bg-danger-800 bg-success-gradient">
			<h2>
				{{ __t('LIST') }} <span class="fw-300"><i>{{__t('ORGANIZATIONS')}}</i></span>
			</h2>
			<div class="panel-toolbar">
				<button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
					<i class="fal fa-plus"></i>
				</button>
			</div>
		</div>
		<div class="panel-container show pt-1 pb-1">
			<div class="panel-content">
				<b-overlay :show="is_load" rounded="sm">
					<div class="rounded">
						<!-- nav-menu-reset will reset the font colors -->
						<ul class="nav-menu  mb-sm-4 mb-md-0 rounded " v-if="worked_orgs.length > 0">
							<li v-for="org in worked_orgs" :class="{'show_children' : org.children_show}">
								<a href="#" class="waves-effect waves-themed " :class="{'active_filter':is_active_org(org),}">
									<strong class="dl-ref bg-success-500" v-on:click.self="setActive(org)" v-if="org.published">active</strong>
									<strong class="dl-ref bg-danger-500" v-on:click.self="setActive(org)" v-if="!org.published">active</strong>

									<span class="nav-link-text color-black" v-on:click.self="setActive(org)">

									<div>
										<div>
											{{ org.title }}
												<span class="small text-info">
													<i class="fal fa-lock" v-if="org.skeep_sync"></i>
												</span>
												<div class="small badge border border-warning text-black-50  mr-1">
													{{org.provider}}
												</div>

												<div class="mt-1" v-if="org.hasOwnProperty('visible_providers')">
													<div class="small badge border border-info  text-info mr-1" v-for="prov in org.visible_providers" v-if="org.is_on">
														{{ org.human_name }}
													</div>
												</div>
										</div>
									</div>
								</span>
									<i class="fal fa-cog width-2 fs-xxl ml-4" v-on:click.stop="edit(org)"></i>
								</a>
							</li>
						</ul>
						<div class="filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500"></div>
					</div>
				</b-overlay>
			</div>
		</div>

		<org_modal></org_modal>
	</div>
</template>

<script>

import Org_modal from "./org_modal";

export default {
	name: "organizations",
	components: {Org_modal},

	data() {
		return {
			organizations: [],
			is_load: true,
			is_show_modal: false,
            active_filter_org : [],
		}
	},

	created () {
		EventBus.$on('reload_organizations',this.load_organizations);
		this.load_organizations();
	},

	methods : {

		create() {
			EventBus.$emit("org_edit", 0);
		},

		is_active_org(item) {
			let is_active = false;
			this.active_filter_org.map(id => {
				if (parseInt(id) === parseInt(item.id)) {
					is_active = true;
				}
			})
			return is_active;
		},

		edit(item) {
			EventBus.$emit("org_edit", parseInt(item.id));
		},

		setActive(item) {

            const id = parseInt(item.id);
            if (this.active_filter_org.includes(id)) {
                this.active_filter_org = this.active_filter_org.filter(v => v !== id);
            } else {
                this.active_filter_org.push(id);
            }

            this.$emit('input', this.active_filter_org);
            EventBus.$emit('org_filter_changed', {
                "type": "organizations",
                "value": this.active_filter_org
            });
		},

		async load_organizations() {
			this.organizations = [];
			this.is_load = true;

			await api.post('/internal/v1/catalog/organizations').then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.organizations = data.data;
					this.organizations.map(item => {
						item.is_active = false;
					})

				} else {
					this.organizations = [];
				}
			}).catch(({response}) => {
				this.is_load = false;
				this.organizations = [];
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		}
	},

	computed : {
		/*...mapFields([
			'all_filter',
			'filter'
		]),

		active_filter_org: {
			get: function () {
				if (this.all_filter.hasOwnProperty('organizations')) {
					if (this.all_filter.organizations == null) {
						return [];
					}
					return this.all_filter.organizations;
				}

				return [];
			},
			set: function (newValue) {
				//Set active categs
			}
		},*/

		worked_orgs() {
			return this.organizations;
		},
	}

}
</script>

<style scoped>
.categ_bg {
	background-color: #eeeeee2e;
}

.children_info {
	width: 15px;
	height: 15px;
	cursor: row-resize;
	text-align: center;
}

a.active_filter {
	border-left: 3px solid #584475;
	background: #eee;
}

li.show_children ul {
	display: block;
}

</style>
